/* eslint no-underscore-dangle: ["error", { "allow": ["_created", "_items"] }] */
import PropTypes from 'prop-types';

import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { RaisedButton } from 'material-ui';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/chevron-left';

import actions from '../../state/actions';

import { guestServices as GuestServiceStatus, houseKeeping as HousekeepingStatus } from '../../config/service-options';
import Select from '../../components/Select';
import HasPermissions from '../../components/HasPermissions';
import withAffiliateConfig from '../../utils/with-affiliate-config';
import Screen from '../../components/Screen';
import { HistoryType } from '../../types/router';
import { localize } from '../../i18n';

import './RoomDetail.css';
import { LOCATION_UPDATE } from '../../state/types';

function renderDeparture(id, checkoutDate) {
  if (checkoutDate) {
    const dateList = moment(checkoutDate).format('MMMM Do').split(' -- ');
    return dateList.map((dt, idx) => (
      <span key={`departure-${id}-${idx}`}>{dt}</span>
    ));
  }
  return null;
}

class RoomDetail extends React.Component {
  constructor(props) {
    super(props);
    this.didProcessRequest = false;
    this.state = {
      housekeeping_status: this.props.room ? this.props.room.attributes.housekeeping_status : null,
      guest_service_status: this.props.room ? this.props.room.attributes.guest_service_status : null,
      form: {},
      formUpdated: false,
      updating: false,
    };
  }

  componentWillMount() {
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(this.props.locationId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.actionType === 'API_UPDATE_FAILED') {
      this.setState({
        updating: false,
      });
    }
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(this.props.locationId);
    }
    if (this.state.guest_service_status === null && nextProps.actionType === 'API_READ' && nextProps.room) {
      this.setState({
        guest_service_status: nextProps.room.attributes.guest_service_status.toLowerCase(),
      });
    }
    if (this.state.housekeeping_status === null && nextProps.actionType === 'API_READ' && nextProps.room) {
      this.setState({
        housekeeping_status: nextProps.room.attributes.housekeeping_status,
      });
    }
  }

  handleChange(value, name) {
    let housekeepingStatus = this.state.housekeeping_status;
    let guestServiceStatus = this.state.guest_service_status;
    const newFormValues = Object.assign({}, this.state.form);
    newFormValues[name] = value;
    if (name === 'guest_service_status') {
      guestServiceStatus = value;
    }
    if (name === 'housekeeping_status') {
      housekeepingStatus = value;
    }
    this.setState({
      housekeeping_status: housekeepingStatus,
      guest_service_status: guestServiceStatus,
      form: newFormValues,
      formUpdated: true,
    });
  }

  handleLocationUpdate() {
    const {
      dispatch,
      locationId,
      history,
    } = this.props;

    if (this.state.formUpdated === true) {
      this.setState({
        updating: true,
      });
      const payload = {
        id: locationId,
        type: 'location',
        attributes: this.state.form,
      };

      dispatch({
        type: LOCATION_UPDATE,
        payload,
      });

      dispatch(actions.updateLocation(locationId, payload))
        .then(() => history.push('/access/rooms'));
    }
    return false;
  }

  render() {
    const {
      room,
      reservations,
      hasPermissions,
    } = this.props;
    let roomDetailInfo = (
      <div className="md-card">
        <div className="md-card-content" />
      </div>
    );

    let activeReservations = [];
    let guest = null;
    let guestInfo = (
      <div>{' '}</div>
    );
    let checkoutStatus = (
      <h3 className="md-card-toolbar-heading-text uk-text-danger">
        {this.props.t('Checked Out')}
      </h3>
    );

    if (reservations.length > 0) {
      activeReservations = _.filter(reservations, (reservation) => {
        const {
          attributes: { state },
          relationships: { locations: { data: [location] } },
        } = reservation;
        if (location && room) {
          if (location.id === room.id && state !== 'checked_out') {
            return true;
          }
        }
        return false;
      });
      if (activeReservations.length > 0) {
        guest = activeReservations[0];
      }
    }

    if (guest !== null) {
      guestInfo = [
        <div key="guest-name" className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Guest')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            {`${guest.attributes.first_name} ${guest.attributes.last_name}`}
          </div>
        </div>,
        <div key="guest-email" className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Guest email')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            {guest.attributes.email}
          </div>
        </div>,
        <div key="guest-departure" className="uk-grid">
          <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
            <h4 className="uk-margin-small-bottom">{this.props.t('Departure Date')}</h4>
          </div>
          <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
            {renderDeparture(guest.id, guest.attributes.checkout_date)}
          </div>
        </div>,
      ];
      checkoutStatus = (
        <h3 className="md-card-toolbar-heading-text uk-text-success">
          {this.props.t('Checked In')}
        </h3>
      );
    }

    if (room !== undefined) {
      const submitButtonDisabled = this.state.formUpdated === false;
      let housekeepingStatusLabel = '';
      let guestServiceStatusLabel = '';

      if (this.state.housekeeping_status !== null) {
        const houseKeepingStatusConfig = _.find(HousekeepingStatus, { value: this.state.housekeeping_status });
        if (houseKeepingStatusConfig) {
          housekeepingStatusLabel = houseKeepingStatusConfig.label;
        }
      }

      if (this.state.guest_service_status !== null) {
        const guestServiceStatusConfig = _.find(GuestServiceStatus, { value: this.state.guest_service_status });
        if (guestServiceStatusConfig) {
          guestServiceStatusLabel = guestServiceStatusConfig.label;
        }
      }

      roomDetailInfo = (
        <div id={room.id} className="md-card">
          <div className="md-card-toolbar">
            <div className="md-card-toolbar-actions">
              {this.props.t('Room {roomAttributesName}', { roomAttributesName: room.attributes.name })}
            </div>
            {checkoutStatus}
          </div>
          <div className="md-card-content">
            <div className="form-detail">
              {guestInfo}

              <HasPermissions config="gems_housekeeping_enabled">
                <div className="uk-grid">
                  <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
                    <h4 className="uk-margin-small-bottom">{this.props.t('Housekeeping Status')}</h4>
                  </div>
                  <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
                    <HasPermissions
                      permissions={['gems.housekeeping_status', 'locations.update']}
                      or={() => housekeepingStatusLabel}
                    >
                      <Select
                        name="form-field-housekeeping_status"
                        value={this.state.housekeeping_status}
                        options={HousekeepingStatus.map(o => (
                          {
                            ...o,
                            label: this.props.t(o.label),
                          }
                        ))}
                        onChange={evt => this.handleChange(evt, 'housekeeping_status')}
                        clearable={false}
                        openAfterFocus
                      />
                    </HasPermissions>
                  </div>
                </div>
              </HasPermissions>

              <HasPermissions config="gems_guest_service_enabled">
                <div className="uk-grid">
                  <div className="uk-width-medium-2-5 uk-width-mobile-1-3 form-heading">
                    <h4 className="uk-margin-small-bottom">{this.props.t('Guest Service Status')}</h4>
                  </div>
                  <div className="uk-width-medium-3-5 uk-width-mobile-2-3 form-value">
                    <HasPermissions
                      permissions="locations.update"
                      or={() => guestServiceStatusLabel}
                    >
                      <Select
                        name="form-field-guest_service_status"
                        value={this.state.guest_service_status}
                        options={GuestServiceStatus.map(o => (
                          {
                            ...o,
                            label: this.props.t(o.label),
                          }
                        ))}
                        onChange={evt => this.handleChange(evt, 'guest_service_status')}
                        clearable={false}
                        openAfterFocus
                      />
                    </HasPermissions>
                  </div>
                </div>
              </HasPermissions>
            </div>
          </div>
          <div className="md-card-footer uk-text-right">
            <Link to="/access/rooms">
              <RaisedButton icon={<ArrowBackIcon />} label={this.props.t('Back')} />
            </Link>

            <RaisedButton
              label={this.props.t('Update')}
              primary
              style={{ marginLeft: '.5em' }}
              disabled={submitButtonDisabled || !hasPermissions('locations.update')}
              onClick={() => this.handleLocationUpdate()}
            />
          </div>
        </div>
      );
    }
    return (
      <Screen title={this.props.t('Rooms')} helpUrl="#rooms">
        <div className="RoomDetail">
          <div className="uk-grid uk-flex-center">
            <div className="uk-width-small-4-5 uk-width-mobile-1-1">
              {roomDetailInfo}
            </div>
          </div>
        </div>
      </Screen>
    );
  }
}

RoomDetail.propTypes = {
  // eslint-disable-next-line
  actionType: PropTypes.string,
  locationId: PropTypes.string,
  room: PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    attributes: PropTypes.shape({
      housekeeping_status: PropTypes.string,
      guest_service_status: PropTypes.string,
      name: PropTypes.string,
      is_locked: PropTypes.bool,
    }),
  }),
  reservations: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    attributes: PropTypes.shape({
      state: PropTypes.string,
    }),
    relationships: PropTypes.shape({
      locations: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.string,
        })),
      }),
    }),
  })),
  processRequest: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  history: HistoryType,
  hasPermissions: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  let locations = [];
  let reservations = [];
  let totalLocations = 0;
  let dataFilters = false;
  let room;

  const {
    match: {
      params: {
        locationId,
      },
    },
  } = ownProps;

  const actionType = state.action.type;
  if (state.api.location) {
    locations = state.api.location.data;
    room = _.find(locations, { id: locationId });
    totalLocations = locations.length;
  }
  if (state.filter.location) {
    locations = state.filter.location;
    dataFilters = true;
  }
  if (state.api.reservation) {
    reservations = state.api.reservation.data;
  }
  return {
    locationId,
    actionType,
    locations,
    room,
    reservations,
    totalLocations,
    dataFilters,
  };
};

const mapDispatchToProps = dispatch => ({
  filterLocations(key, value) {
    if (value !== null && value !== '') {
      dispatch(actions.filterLocations(key, value.toString()));
    } else {
      dispatch(actions.clearFilterLocations());
    }
  },
  processRequest(roomId) {
    dispatch(actions.retrieveLocationById(roomId));
  },
  dispatch,
});

export default localize(withAffiliateConfig(connect(mapStateToProps, mapDispatchToProps)(RoomDetail)));



// WEBPACK FOOTER //
// ./src/views/rooms/RoomDetail.js